<template>
    <!-- <router-link
        :to="link"
        style="text-decoration: none; color: inherit"
    > -->
    <v-card
        elevation="8"
        class="my-1"
        @click="setTicketFilter(label)"
    >
        <v-list-item two-line>
            <v-list-item-avatar
                rounded
                size="40"
                :color="iconBackgroundColor"
            >
                <v-icon
                    class="material-icons-outlined"
                    :color="iconColor"
                >
                    {{ icon }}
                </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <span class="label">
                    {{ label }}
                </span>
                <span class="content">
                    {{ content }}
                </span>
            </v-list-item-content>
        </v-list-item>
    </v-card>
    <!-- </router-link> -->
</template>
<script>
import   {setTicketFilter}  from '../services/ticketTabs';
export default {
    props: {
        link: {
            type: String,
            required: true
        },
        iconBackgroundColor: {
            type: String,
            required: true
        },
        iconColor: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        content: {
            type: [Number, String],
            required: true
        },
    },    
    methods: {
        setTicketFilter(filter) {
            setTicketFilter(filter);
        },
    }
};
</script>
<style scoped>
.label {
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    color: #7F8592;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.content {
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
    color: #35383F;
}
</style>
